import React from "react";
import PropTypes from "prop-types";
import { NavLink } from "react-router-dom";
import { Button } from "react-bootstrap";
import { Settings as SettingsIcon } from "@mui/icons-material";
import PeopleIcon from "@mui/icons-material/People";
import CardGiftcardIcon from "@mui/icons-material/CardGiftcard";
import ImageSearchIcon from "@mui/icons-material/ImageSearch";
import "./Sidebar.scss";
import profileIcon from "../../assests/images/profile.svg";

const Sidebar = ({ newHeight }) => {
  let sidebarHeight = "968px";

  if (newHeight === "user") {
    sidebarHeight = "1275px";
  } else if (newHeight === "gift") {
    sidebarHeight = "950px";
  }

  return (
    <div
      className="sidebar"
      id="customSidebar"
      style={{ height: sidebarHeight }}
    >
      <ul className="nav flex-column">
        <NavLink
          to="/app-users"
          activeClassName="active"
          exact={true}
          className="sidebar-link"
        >
          <Button className="sidebar-button" variant="light">
            <span className="sidebar-icon">
              <img src={profileIcon} alt="profile" />
            </span>
            <b>App Users</b>
          </Button>
        </NavLink>

        <NavLink
          to="/gifts"
          activeClassName="active"
          exact={true}
          className="sidebar-link"
        >
          <Button className="sidebar-button" variant="light">
            <span className="sidebar-icon">
              <CardGiftcardIcon />
            </span>
            <b>Gifts</b>
          </Button>
        </NavLink>
        <NavLink
          to="/moderation"
          activeClassName="active"
          exact={true}
          className="sidebar-link"
        >
          <Button className="sidebar-button" variant="light">
            <span className="sidebar-icon">
              <ImageSearchIcon />
            </span>
            <b>Moderation</b>
          </Button>
        </NavLink>
        <NavLink
          to="/admin-users"
          activeClassName="active"
          exact={true}
          className="sidebar-link"
        >
          <Button className="sidebar-button" variant="light">
            <span className="sidebar-icon">
              <PeopleIcon />
            </span>
            <b>Admin Users</b>
          </Button>
        </NavLink>
        <NavLink
          to="/system-settings"
          activeClassName="active"
          exact={true}
          className="sidebar-link"
        >
          <Button className="sidebar-button" variant="light">
            <span className="sidebar-icon">
              <SettingsIcon />
            </span>
            <b>System Settings</b>
          </Button>
        </NavLink>
      </ul>
    </div>
  );
};

Sidebar.propTypes = {
  newHeight: PropTypes.string,
};

export default Sidebar;
